import apiClient from "./axios";

const subcategoryApi = {
  // GET all (pagination + search)
  getAll: async (page = 1, pageSize = 10, search = "") => {
    const r = await apiClient.get("/subcategories/", {
      params: { page, page_size: pageSize, search },
    });
    return r.data; // { data: [...], pagination: {...} }
  },

  // GET by ID
  getById: async (id) => {
    const r = await apiClient.get(`/subcategories/${id}/`);
    return r.data;
  },

  // CREATE
  create: async (data) => {
    const r = await apiClient.post("/subcategories/", data);
    return r.data;
  },

  // UPDATE (partial)
  update: async (id, data) => {
    const r = await apiClient.patch(`/subcategories/${id}/`, data);
    return r.data;
  },

  // DELETE
  delete: async (id) => {
    await apiClient.delete(`/subcategories/${id}/`);
    return true;
  },

  /* -------------------------- EXPORT -------------------------- */
  exportCsv: async () => {
    const response = await apiClient.get("/subcategories/export/", {
      responseType: "blob",
    });
    return response.data; // Blob
  },

  /* -------------------------- IMPORT PREVIEW -------------------------- */
  importPreview: async (file) => {
    const form = new FormData();
    form.append("file", file);
    const response = await apiClient.post(
      "/subcategories/import-preview/",
      form,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response.data; // { preview: [...], total: number, errors: [...] }
  },

  /* -------------------------- IMPORT CONFIRM -------------------------- */
  importConfirm: async (preview) => {
    const response = await apiClient.post("/subcategories/import-confirm/", {
      preview,
    });
    return response.data;
  },
};

export default subcategoryApi;
